/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vYWRtaW4vdXNlci9lZGl0LXJldmlldy10cmFuc2xhdG9yL2VkaXQtcmV2aWV3LXRyYW5zbGF0b3IuY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
